import React from "react";
import "../styles/legal.css";

const PrivacyPolicy = () => {
  return (
    <section id="privacy" className="privacy-section py-5">
      <div className="container">
        <div className="text-center mb-4 pt-1">
          <h2 className="fw-bold pt-5">Adatkezelési tájékoztató</h2>
          <div className="privacy-divider mx-auto my-3"></div>
          <p className="mb-4 text-muted">
            Jelen tájékoztató a weboldalon keresztül megvalósuló adatkezelés
            szabályait rögzíti a GDPR és az Info tv. alapján.
          </p>
        </div>
        <div className="privacy-policy mt-5">
          <h3>1. Adatkezelő adatai</h3>
          <p>
            <strong>Név:</strong> Dr. Dósa Nikolett
            <br />
            <strong>E-mail:</strong> <a href="mailto:info@domain.hu"></a>
          </p>

          <h3>2. Kezelt adatok köre</h3>
          <ul>
            <li>Név</li>
            <li>Telefonszám</li>
            <li>E-mail cím</li>
            <li>Üzenet tartalma</li>
          </ul>

          <h3>3. Adatkezelés célja</h3>
          <p>
            Kapcsolatfelvétel és megkeresések kezelése az érintett
            hozzájárulásával.
          </p>

          <h3>4. Megőrzési idő</h3>
          <p>Az adatokat legfeljebb 90 napig tároljuk.</p>

          <h3>5. Panasztétel</h3>
          <p>
            Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH) <br />
            <a href="https://www.naih.hu" target="_blank" rel="noreferrer">
              www.naih.hu
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
